module.exports = __webpack_public_path__ + "static/media/edoc-logo.c247a4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edoc-logo.png
// module id = 1715
// module chunks = 2